/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import PropTypes from "prop-types";
import gl_arrow_down from "../../assets/gl_arrow_down.svg";
import gl_arrow_up from "../../assets/gl_arrow_up.svg";
import "./styles.scss";
import Button from "../common/Button";

const ButtonHeaderDropDown = ({ name, items, handleRoute }) => {
  const [showOptions, setShowOptions] = useState(false);

  const handleShowOptions = () => {
    setShowOptions(!showOptions);
  };
  const handleShowOptions2 = () => {
    setShowOptions(true);
  };
  const handleCloseOptions2 = () => {
    setShowOptions(false);
  };

  return (
    <>
      <div className="button-drop-down" onMouseOver={handleShowOptions2} onMouseLeave={handleCloseOptions2}>
        <Button primary size="small" className="" >
          {name}
          <img
            src={!showOptions ? gl_arrow_down : gl_arrow_up}
            className="headerBtn--img headerBtn--img--right "
            alt="chevrot icon"
          />
        </Button>
        <ul
          className={`buttonheaderDropDown-menu ${
            showOptions ? "show" : "hide"
          }`}
        >
          {items.map((item, index) => {
            return <li key={index} className="paragraph paragraph-14 text-center" onClick={()=> handleRoute(item.path)}>{item.name}</li>
          })}
        </ul>
      </div>
    </>
  );
};

ButtonHeaderDropDown.defaultProps = {
  username: "UTEST",
};

ButtonHeaderDropDown.propTypes = {
  username: PropTypes.string,
};

export default ButtonHeaderDropDown;
